import { useCallback } from 'react';
import { useFieldArray } from '../../../contexts';
import { createBlankClause } from '../../../utils/conditionalContent/createBlankClause';

export const useAddClause = () => {
  const { append } = useFieldArray({ name: 'conditionalContent.elseIfClauses' });
  return useCallback(() => append(createBlankClause()), [append]);
};
